'use client';

import React from 'react';
import { cn } from '@/lib/_utils/cn';

interface AuthBlockProps {
	children: React.ReactNode;
	title?: string;
	subtitle?: string;
	wrapProps?: React.HTMLAttributes<HTMLDivElement>;
}

export default function AuthBlock({ children, title, subtitle, wrapProps }: AuthBlockProps) {
	return (
		<div
			{...wrapProps}
			className={`${cn('mx-auto w-full max-w-[400px] rounded-[10px] bg-dark-900 p-[40px] sm:p-[24px]', wrapProps?.className)}`}>
			{(title || subtitle) && (
				<div className={`mb-[20px] grid gap-lg`}>
					{title && (
						<div className='text-[20px] font-semibold lg:text-lg' dangerouslySetInnerHTML={{ __html: title }}></div>
					)}
					{subtitle && <div className='text-md text-dark-300' dangerouslySetInnerHTML={{ __html: subtitle }}></div>}
				</div>
			)}
			<div>{children}</div>
		</div>
	);
}
